import * as React from "react";
import { isBlackDecember } from "src/util/blackDecember";
import BlackDecemberDashboard from "./black-december/BlackDecemberDashboard";

export function Welcome(props) {
  return <>{isBlackDecember && <BlackDecemberDashboard {...props} />}</>;
}



// WEBPACK FOOTER //
// ./src/pages/welcome/Welcome.tsx